<template>
  <v-container grid-list-md fluid>
      <v-layout row >
          <v-flex md12 >
            <v-card>
            <!--<div class="ibox float-e-margins animated fadeInUp">-->
            <!-- <div class="ibox float-e-margins"> -->
              
              <v-toolbar dense primary-title>
                <v-toolbar-title>{{$t('view.bitacora.filtros.label')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
                  <v-icon>{{ view.elem.showForm ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                </v-btn>
              </v-toolbar>
              <v-slide-y-transition>
                <v-card-text v-show="view.elem.showForm">
                  <v-layout row>
                    <v-flex md12>
                      <v-form role="form">
                        <!-- Skeleton loader -->
                        <div v-if="view.action.submit.busy">
                          <vue-content-loading :width="450" :height="158">
                            <rect x="0" y="0" rx="4" ry="4" width="53" height="10" />
                            <rect x="0" y="15" rx="4" ry="4" width="442" height="34" />
                            <rect x="0" y="64" rx="4" ry="4" width="53" height="10" />
                            <rect x="0" y="79" rx="4" ry="4" width="442" height="34" />
                            <rect x="0" y="128" rx="10" ry="10" width="80" height="30" />
                          </vue-content-loading>
                        </div>
                        <v-layout row>
                          <v-flex md5>
                            <div v-if="!view.action.submit.busy" 
                              v-bind:class="[hasErrors($v.bitacora.usuario_username)?'has-error':'']">
                              <v-combobox 
                                v-model="$v.bitacora.usuario_username.$model"
                                :items="view.elem.select.usuario_username.options"
                                :label="$t('view.bitacora.usuario_username.label')"
                                :error-messages = "$t(`validator.${getFirstError($v.bitacora.usuario_username)}.text`,'')"
                                item-text="name"
                                item-value="code"
                                :max-height="200" 
                                multiple
                                dense   
                                clearable
                                deletable-chips  
                                hide-no-data                         
                                small-chips>
                              </v-combobox>
                            </div>
                          </v-flex>
                          <v-flex md3 >
                            <div v-if="!view.action.submit.busy" >
                              <v-dialog
                                ref="dialogInicio"
                                v-model="modalFechaInicio"
                                :return-value.sync="$v.bitacora.fecha_inicio.$model"
                                persistent
                                lazy
                                full-width
                                width="290px">
                                <v-text-field
                                  slot="activator"
                                  v-model="formatFechaInicio"
                                  :error-messages = "$t(`validator.${getFirstError($v.bitacora.fecha_inicio)}.text`,'')"
                                  :label="$t('view.bitacora.fecha_inicio.label')"
                                  prepend-icon="event"
                                  readonly>
                                </v-text-field>
                                <v-date-picker 
                                :max="$v.bitacora.fecha_fin.$model"
                                locale="es-ES" v-model="$v.bitacora.fecha_inicio.$model" scrollable>
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="modalFechaInicio = false">Cancel</v-btn>
                                  <v-btn flat color="primary" @click="$refs.dialogInicio.save($v.bitacora.fecha_inicio.$model)">OK</v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </div>
                          </v-flex>
                          <v-flex md3>
                            <div  v-if="!view.action.submit.busy" >
                              <v-dialog
                                ref="dialogFin"
                                v-model="modalFechaFin"
                                :return-value.sync="$v.bitacora.fecha_fin.$model"
                                persistent
                                lazy
                                full-width
                                width="290px">
                                <v-text-field
                                  slot="activator"
                                  v-model="formatFechaFin"
                                  :error-messages = "$t(`validator.${getFirstError($v.bitacora.fecha_fin)}.text`,'')"
                                  :label="$t('view.bitacora.fecha_fin.label')"
                                  prepend-icon="event"
                                  readonly>
                                </v-text-field>
                                <v-date-picker 
                                :min="$v.bitacora.fecha_inicio.$model"
                                locale="es-ES" v-model="$v.bitacora.fecha_fin.$model" scrollable>
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="modalFechaFin = false">Cancel</v-btn>
                                  <v-btn flat color="primary" @click="$refs.dialogFin.save($v.bitacora.fecha_fin.$model)">OK</v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </div>
                          </v-flex>
                          <v-flex md1>
                            <div class="form-group text-center">
                              <label></label>
                              <button type="button" style="margin-top: 25px;" 
                                  title="Buscar"
                                  class="btn btn-outline btn-circle btn-primary" 
                                  @click="submit()">
                                  <i class="fa fa-search"></i>
                                </button>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-slide-y-transition>
            <!-- </div> -->
            </v-card>
          </v-flex>
      </v-layout>
      <v-layout row >
          <v-flex md12>
            <data-table ref="tableBitacora"></data-table>
          </v-flex>
      </v-layout>
  </v-container>
</template>
<script>
import {BitacoraModel} from "@/models/bitacoras/bitacora";
import CombosAPI from "@/services/catalogos";
import {required} from "vuelidate/lib/validators";
import {minDateFrom, maxDateFrom} from "@/helpers/vuelidate/validators";
import {allValidatorMethods} from "@/helpers/vuelidate";
import VueContentLoading from 'vue-content-loading';
import DataTable from "@/views/bitacoras/bitacora/DataTable";
import Multiselect from 'vue-multiselect';
import tippy from 'tippy.js';
import * as states from "@/views/bitacoras/bitacora/bitacora-states";
import * as R from "ramda";
import * as dateMethods from "@/helpers/date-methods";
//Element's Settings
const button = {
  submit:{
    enable:true
    , text:""
  }
};
let select = {
  usuario_username:{
    options:[{name:'Administrador', code:'administrador'}]
  }
  ,  usuario_usernameAll:{
    options:[]
  }
  
}
//Action's state
const action = {
  submit:{
    busy:false
  }
};

//Initial Model
//const bitacora = new BitacoraModel();
//Helpers
function evaluateModelChangedMethodResult(data){
  if(!data && typeof data === "boolean"){
  return data
  }

  if(data && typeof data === "object"){
  return data.length>=1;
  } 
}
const modelIsModified = R.curry((model)=>R.compose(evaluateModelChangedFlag,model.changed));

export default {
  name: "Bitacoras",
  head:{
    title:function(){
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      }
    }
  }
  , data() {
    let _locale = this.$store.language;
    return {
      locale: _locale
      , date: undefined
      , dateFin: undefined
      , bitacora : undefined
      , modalFechaInicio : false
      , modalFechaFin : false
      , state : new Object()
      , view:{
        title:"Bitácora de Acceso"
        , action
        , elem:{
          button
          , select
          , showForm: true
        }
      }
      , check:true
    };
  }
  ,methods: {
    ...allValidatorMethods
    , async submit(){
      try{
        this.$refs.tableBitacora.refreshData();
      }catch(error){
      }
    }
    , async loadBitacora(idBitacora){
      try{
        // const response = await BitacoraAPI.get({clave:idBitacora});
        // console.log(response)
        // const {data:{results:{bitacora}}} = response;
        // Object.setPrototypeOf(this.state, new states.EditingState(this,bitacora));
      }catch(error){
        console.log(error)
      }
    }
    , addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    }
    , getLimitText(){
      return count=> ` y  ${count} más `;
    }
  }
  , computed:{
    formatFechaInicio(){
      return dateMethods.formatDate(this.$v.bitacora.fecha_inicio.$model);
    }
    ,formatFechaFin(){
      return dateMethods.formatDate(this.$v.bitacora.fecha_fin.$model);
    }
  }
  , validations:{
    bitacora:{
      usuario_username:{
        required:false
      }
      , fecha_inicio:{
        required
        , maxDateFrom: maxDateFrom('fecha_fin')
      }
      , fecha_fin:{
        required
        , minDateFrom : minDateFrom('fecha_inicio') 
      }
    }
  }
  , components: {
    VueContentLoading
    , DataTable
    , Multiselect
  }
  // Instance Lifecycle Hooks
  , async created(){
    Object.setPrototypeOf(this.state, new states.InitialState(this));
    const responseCombosUsuariosActive = await CombosAPI.get({tipo:'usuariosActive'});
    select.usuario_username.options = responseCombosUsuariosActive.data.results.combo;
    const responseCombosUsuariosAll = await CombosAPI.get({tipo:'usuarios'});
    select.usuario_usernameAll.options = responseCombosUsuariosAll.data.results.combo;
  }
  , beforeMount(){
  }
  , mounted(){
    this.$v.$reset();
    // this.$parent.appJQueryConfigMethod();
    this.$nextTick(function(){
      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bitacoras/bitacora/Bitacora.vue